module.exports = __webpack_public_path__ + "static/media/voucher.80178068.svg";